import { Helper } from "../../core/util/helper";
import { AppBaseProps, CommonApp } from "../../core/components/commonApp";
import { AppHelper } from "../../appHelper";
import { MetaDataHelper } from "../../core/util/metaDataHelper";
import { SheetEventType } from "../../../siteManagement/sheet";
import { WorkPackageRequirementGridEntity } from "./workPackageCapacityRequimentsGrid";
import { StringKeyDictionary } from "../../commonInterfaces";
import React from "react";
export class EditWorkPackageCapacityRequirement extends React.Component<EditWorkPackageCapacityRequirementProps, any> {
    common = new AppHelper();
    translations: StringKeyDictionary<string>;

    constructor(props: EditWorkPackageCapacityRequirementProps | Readonly<EditWorkPackageCapacityRequirementProps>) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }
    apply = () => {
        if (this.common.validate()) {
            this.common.setEntityDirtyState(false);
            this.common.sheetWrapper.trigger(SheetEventType.SavedSuccessfully, this.props.entity);
            this.common.sheetWrapper.hide();
        }
    }
    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        switch (field.model) {
            case ("entity.GrNr"): 
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Bezeichnung", dataItem.Text);
                }
                break;
            case ("entity.IsGroup"):
                {
                    if (value) 
                        this.props.entity.ResNo = null;
                    else
                        this.props.entity.GrNr = null;
                }
                break;
            case ("entity.PlanningBoardFlagId"):
                this.props.entity.PlanningBoardFlagName = dataItem.Name;
                break;
            case("entity.StartMinutes"):
                this.props.entity.StartMinutesString = Helper.dates.fromMinutesSinceMidnight(value);
                break;
            case "entity.ResNo":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.ResNo", dataItem.Ressnr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Name", dataItem.Name);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Vorname", dataItem.Vorname);
                }
                break;
            default:
                break;
        }

        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }
    handleIsSearchFieldFullObjectModel = (field: {model:string}, dataItem: {ressnr: string, name: string, vorname: string}) => {
        let changed = true;
        switch (field.model) {
            case "entity.ResNo":
                if (Helper.hasValue(dataItem)) {
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.ResNo", dataItem.ressnr);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Name", dataItem.name);
                    MetaDataHelper.setFieldValue(this.props.entity, "entity.Vorname", dataItem.vorname);
                }
                break;
            default:
                changed = false;
                break;
        }
        if (changed) {
            this.common.handleFieldChange({ model: "" }, null, null);
        }
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange, handleIsSearchFieldFullObjectModel: this.handleIsSearchFieldFullObjectModel });
        return <CommonApp {...props} />;
    }
}


export interface EditWorkPackageCapacityRequirementProps extends AppBaseProps {
    entity: WorkPackageRequirementGridEntity;
    disabled: boolean;
}